
import React, { useState } from 'react';
import '../styles/changePassword.css';
import { resetPasswordAction } from '../redux/slices/userSlices';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Message from './Message';
// npm i before running this file.
const ResetPasswordLink = () => {
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const {token} = useParams();
  const dispatch = useDispatch();
  const handlepassword = (e) => setPassword(e.target.value);
  

  const resetPass = ()=>{
    const data = {
        password : password,
        token : token,
    }

    dispatch(resetPasswordAction(data));

    navigate('/');
  }

  return (
    <>
    <Message/>
    <div className="password-container">
      <div className="pass-box">
        
          <h2>Reset Password</h2>
          <div className="input-group">
            <label htmlFor="old-password">Password :</label>
            <input
              type="password"
              id="old-password"
              value={password}
              onChange={handlepassword}
              placeholder="Enter New Password"
            />
          </div>
          

          <div className="buttons">
            <button className="save-btn" onClick={resetPass} >Reset</button>
          </div>
        </div>
      
    </div>
    </>
  );
};

export default ResetPasswordLink;
